import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PrimaryFooter, SecondaryFooter } from '../../../Footer/index.js';
export const ErrorBoundaryFooter = ({ appearance = 'primary' }) => {
    switch (appearance) {
        case 'secondary':
            return _jsx(SecondaryFooter, {});
        case 'primary':
        default:
            return _jsx(PrimaryFooter, {});
    }
};
//# sourceMappingURL=index.js.map